import { styled } from '@mui/material';
import { DataGrid as MUIDataGrid } from '@mui/x-data-grid';
import { useMediaQuery } from 'react-responsive';

export const DataGrid = styled(MUIDataGrid)(() => {
  const isMobile = useMediaQuery({ query: '(max-width: 899.5px)' });

  return {
    '& .MuiDataGrid-columnHeaderTitle': {
      fontSize: isMobile ? '.65rem' : '.75rem'
    }
  };
});
